<template>
  <div class="container">
    <div
      class="nav-item"
      v-for="(item,index) in navList"
      :key="item.id"
      @mousemove="showSubNav=index"
      @mouseleave="showSubNav=''"
      @click="openWin(item)"
    >
      <span :class="(index !== 0 && index === showSubNav) ?  'item-hover' : ''">{{item.title}}</span>
      <transition name="fade">
        <ul v-show="index !== 0 && index === showSubNav" class="sub-nav">
          <li v-for="list in subList[index]"  :key="list.value" @click="openNew(list)" >{{list.label}}</li>
        </ul>
      </transition>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapMutations } from 'vuex'
import { orgId, requestUrl } from '../common/cons'
export default {
  name: "Navigation",
  props: {
    navList: {
      type: Array,
      required: true
    },
    subList: {
      type: Array,
      required: true
    }
  },
  data(){
    return{
      showSubNav:"",

    }
  },
  methods:{
  ...mapMutations([
      'updateMainColumnId'
    ]),
      openWin(str){
      if(str.title==='首页'){
        this.$router.push({
          path: `/`
        })
      }
    },
    async openNew(list){
      if (list.type === 'channel') {
        this.$router.push({
          path: `/news/${list.value}`
        })
        this.updateMainColumnId(list.value)
      } else {
        const result = await axios.get(`${requestUrl}/news/article?id=${list.value}&orgId=${orgId}`)
        // console.log(result)
        const articleId = result.data[0].id
        this.$router.push({
          path: `/content/${articleId}`
        })
      }
    }
  },
}
</script>

<style scoped>
.container {
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
justify-content: center;
  background-color: #088A29;
}

.nav-item {
  height: 100%;
  width: 160px;
  font-size: 18px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  transition: all .5s;
}

.sub-nav {
  position: absolute;
  top: 28px;
  width: 100%;
  /*background-color: rgb(7, 90, 154);*/
  background-color: #088A29;
  color: #fff;
  z-index: 999;
  box-sizing: border-box;
  text-align: center;
}

.sub-nav li {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  padding: 14px  0;
  position: relative;
  right: 20px;
}

.sub-nav li:hover {
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #F4FA58;
  cursor: pointer;
  opacity: 0.8;
}

.nav-item:hover {
  cursor: pointer;
  background-color: #088A29;
  background-size: cover;
  color: #F4FA58;
  font-size: 20px;
  transition: all .5s;
  text-align: center;
}

.fade-enter-active, .fade-leave-active {
  transition: all .5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.item-hover {
  font-weight: bold;
  /*margin-left: 20%;*/
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue